export default "/fonts/TiemposHeadline-Regular.eot?ffd54ce00539eb4528dfa0d5e07ebcbb";